import React from "react";
import { Box, Typography } from "@mui/material";

const items = [
  { color: "#2e9b5b", label: "High" },
  { color: "#e0952f", label: "Medium" },
  { color: "#b0b0b0", label: "Low" },
];

const ConfidenceLegend = ({ sx }) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "center",
      flexWrap: "wrap",
      gap: 1.5,
      ...sx,
    }}
  >
    <Typography sx={{ fontSize: 12, color: "text.disabled" }}>
      Confidence:
    </Typography>
    {items.map((it) => (
      <Box
        key={it.label}
        sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
      >
        <Box
          sx={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            bgcolor: it.color,
          }}
        />
        <Typography sx={{ fontSize: 12, color: "text.secondary" }}>
          {it.label}
        </Typography>
      </Box>
    ))}
  </Box>
);

export default ConfidenceLegend;
